<form class="self-stretch" (submit.prevent)="onSubmit()">
  <ui-simple-dialog-layout (clickCancel)="clickCancel.emit()">
    <!-- title -->
    <ng-container slot="title">{{
      'cockpit.locations.createDialog.title' | transloco
    }}</ng-container>
    <!-- content -->
    <div class="flex flex-col sm:grid grid-cols-12 gap-6">
      <ui-input-label class="col-span-12" labelFor="create-location-name">
        <div class="flex">
          <span class="flex-1">{{ 'cockpit.locations.createDialog.nameLabel' | transloco }}</span>
          <span
            class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
          >
            {{ 'validators.optional' | transloco }}
          </span>
        </div>

        <ui-input-simple
          type="text"
          inputId="create-location-name"
          class="block w-full"
          [placeholder]="'cockpit.locations.createDialog.namePlaceholder' | transloco"
          [formField]="locationForm.name"
        />
        <app-field-errors slot="bottom" [fieldState]="locationForm.name()" />
      </ui-input-label>
      <div class="flex flex-col sm:grid grid-cols-12 gap-6 col-span-12">
        <ui-input-label class="col-span-6" labelFor="create-location-zipCode">
          <span>
            {{ 'cockpit.locations.createDialog.zipCodeLabel' | transloco }}
            <span class="text-error dark:text-error-darkmode">*</span>
          </span>
          <ui-input-simple
            type="text"
            inputId="create-location-zipCode"
            [formField]="locationForm.address.zipCode"
          />

          <app-field-errors slot="bottom" [fieldState]="locationForm.address.zipCode()" />
        </ui-input-label>
        <ui-input-label class="col-span-6" labelFor="create-location-city">
          <span>
            {{ 'cockpit.locations.createDialog.cityLabel' | transloco }}
            <span class="text-error dark:text-error-darkmode">*</span>
          </span>
          <ui-input-simple
            type="text"
            inputId="create-location-city"
            [formField]="locationForm.address.city"
          />
          <app-field-errors slot="bottom" [fieldState]="locationForm.address.city()" />
        </ui-input-label>
        <ui-input-label class="col-span-6" labelFor="create-location-street">
          <span>
            {{ 'cockpit.locations.createDialog.streetLabel' | transloco }}
            <span class="text-error dark:text-error-darkmode">*</span>
          </span>
          <ui-input-simple
            type="text"
            inputId="create-location-street"
            [formField]="locationForm.address.street"
          />
          <app-field-errors slot="bottom" [fieldState]="locationForm.address.street()" />
        </ui-input-label>
        <ui-input-label class="col-span-3" labelFor="create-location-streetNumber">
          <span>
            {{ 'cockpit.locations.createDialog.streetNumberLabel' | transloco }}
            <span class="text-error dark:text-error-darkmode">*</span>
          </span>
          <ui-input-simple
            type="text"
            inputId="create-location-streetNumber"
            [formField]="locationForm.address.streetNumber"
          />
          <app-field-errors slot="bottom" [fieldState]="locationForm.address.streetNumber()" />
        </ui-input-label>
        <ui-input-label class="col-span-3" labelFor="create-location-streetNumberSuffix">
          <div class="flex">
            <span class="flex-1">{{
              'cockpit.locations.createDialog.suffixLabel' | transloco
            }}</span>
            <span
              class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
            >
              {{ 'validators.optional' | transloco }}
            </span>
          </div>
          <ui-input-simple
            type="text"
            inputId="create-location-streetNumberSuffix"
            [formField]="locationForm.address.streetNumberSuffix"
          />
          <app-field-errors
            slot="bottom"
            [fieldState]="locationForm.address.streetNumberSuffix()"
          />
        </ui-input-label>
      </div>
    </div>
    <!-- footer -->
    <ui-button
      slot="footer"
      mode="outlined"
      expand="full"
      type="button"
      (click)="clickCancel.emit()"
      class="block"
    >
      {{ 'cockpit.locations.createDialog.cancelButton' | transloco }}
    </ui-button>
    <ui-button
      slot="footer"
      expand="full"
      class="block"
      type="submit"
      [loading]="locationsStore.isCreateLoading() || isEditLoading()"
    >
      @if (locationID()) {
        {{ 'cockpit.locations.createDialog.saveButton' | transloco }}
      } @else {
        {{ 'cockpit.locations.createDialog.submitButton' | transloco }}
      }
    </ui-button>
  </ui-simple-dialog-layout>
</form>
